import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CTASection from "./components/CTASection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import BlogPreview from "./components/BlogPreview";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.forum';

export default function Home() {
  return (
    <>
      <Navbar transparent />
      <main>
        {/* Schema.org WebSite structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Hoobuy Forum",
              "url": siteUrl,
              "description": "O guia mais completo de Hoobuyspreadsheet 2026. Planilhas atualizadas, links verificados e guias de compra seguros.",
              "inLanguage": "pt",
              "potentialAction": {
                "@type": "SearchAction",
                "target": `${siteUrl}/search?q={search_term_string}`,
                "query-input": "required name=search_term_string"
              }
            }),
          }}
        />
        {/* Schema.org Organization structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Hoobuy Forum",
              "url": siteUrl,
              "description": "Hub central de Hoobuyspreadsheet com links verificados e guias de compra atualizados diariamente."
            }),
          }}
        />
        {/* BreadcrumbList Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Início",
                  "item": `${siteUrl}/`
                }
              ]
            }),
          }}
        />
        <Hero />
        <CTASection />
        <CategoryGrid />
        <AboutSection />
        <BlogPreview />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}